import React from "react";
import { Form, Input, DatePicker, Select } from "antd";
import DadataSearch from "../../../../Authorization/containers/DadataSearch/dadataSearch";

const IndividForm = props => {
  const { form, subjectId, handleChange, autoSearchFields } = props;
  const { getFieldDecorator } = form;
  return (
    <div className="add-customer-form__individ">
      <div className="add-customer-form__main-block">
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">
            {subjectId === "individ" ? "ИП" : "Организация"}:
          </span>
          <div className="add-customer-form__item">
            <DadataSearch
              form={form}
              style={{ width: 368 }}
              handleChange={handleChange}
              label=" " //Костыль, чтобы лейбл второй не вылезал.
            />
          </div>
        </div>
        {autoSearchFields ? (
          <>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">Наименование:</span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("nameLegal")(
                    <Input
                      disabled
                      className="add-customer-form__input"
                      style={{ width: 368 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">
                Юридический адрес:
              </span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("companyAddress")(
                    <Input
                      disabled
                      className="add-customer-form__input"
                      style={{ width: 368 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">
                Дата регистрации:
              </span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("registrationDate")(
                    <DatePicker
                      format={"DD.MM.YYYY"}
                      disabled
                      style={{ width: 224 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">ИНН:</span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("inn")(
                    <Input
                      disabled
                      className="add-customer-form__input"
                      style={{ width: 368 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">ОГРНИП:</span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("ogrn")(
                    <Input
                      disabled
                      className="add-customer-form__input"
                      style={{ width: 368 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">Статус:</span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("status")(
                    <Input
                      disabled
                      className="add-customer-form__input"
                      style={{ width: 224 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">
                Система налогообложения:
              </span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("taxSystem", {
                    rules: [
                      {
                        required: true,
                        message: "Поле, обязательное для заполнения"
                      }
                    ]
                  })(
                    <Select
                      getPopupContainer={trigger => trigger.parentNode}
                      style={{ width: 224 }}
                      placeholder="Выберите с или без НДС"
                    >
                      <Select.Option value={0}>Без НДС</Select.Option>
                      <Select.Option value={1}>С НДС</Select.Option>
                    </Select>
                  )}
                </Form.Item>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default IndividForm;
